import {User} from "./model";
import {defineMessages, InjectedIntl} from "react-intl";

type SET_USER = "user/SET_USER";
const SET_USER: SET_USER = "user/SET_USER";
type SET_USER_TOUR_COMPLETED = "user/SET_USER_TOUR_COMPLETED";
const SET_USER_TOUR_COMPLETED: SET_USER_TOUR_COMPLETED = "user/SET_USER_TOUR_COMPLETED";
const MESSAGES = defineMessages({
  ROLE_ERROR: {
    id: "studio.login-page.role-error",
    defaultMessage: "ADMIN or STUDIOMANAGER role required",
  },
  USER_ERROR: {
    id: "studio.login-page.user-error",
    defaultMessage: "Invalid Username or Password",
  }
})

export interface SetUserAction {
  type: SET_USER;
  payload: User;
}

export interface SetUserTourCompletedAction {
  type: SET_USER_TOUR_COMPLETED;
  payload: boolean;
}

const actionTypes = {
  SET_USER,
  SET_USER_TOUR_COMPLETED,
};

const setUser = (user: User): SetUserAction => {
  return {
    type: SET_USER,
    payload: user,
  };
};

const login = ({username, password, redirect}: { username: string; password: string; redirect?: string },
               intl: InjectedIntl) => {
  return (dispatch, getState, {getApi}) => {
    const api = getApi(getState());
    return api.login({username, password, redirect})
        .then(() => api.getCurrentUser())
        .then((user) => {
          if (!user) {
            throw new Error(intl.formatMessage(MESSAGES.USER_ERROR));
          }
          return api.getUser(user).then((userDetails) => {
            if (userDetails.roles.find((str) => str === "ADMIN" || str === "STUDIOMANAGER")) {
              dispatch(setUser(user));
            } else {
              throw new Error(intl.formatMessage(MESSAGES.ROLE_ERROR));
            }
          })
        })
        .catch((error) => {
          return api.logout().then(() => {
            dispatch(setUser(null));
            if (error?.response?.status === 403) { //403 is from api.getUser(user)
              throw new Error(intl.formatMessage(MESSAGES.ROLE_ERROR));
            } else {
              throw new Error(error);
            }
          });
        })
  };
};

const logout = () => {
  return (dispatch, getState, {getApi}) => {
    const api = getApi(getState());
    return api.logout().then(() => {
      dispatch(setUser(null));
    });
  };
};

const setUserTourCompleted = (isUserTourCompleted: boolean) => {
  return (dispatch, getState, {getApi}) => {
    const api = getApi(getState());
    return api.setUserTourCompleted(isUserTourCompleted).then(() => {
      dispatch({type: SET_USER_TOUR_COMPLETED, payload: isUserTourCompleted});
    }).catch((error) => {
      dispatch({type: SET_USER_TOUR_COMPLETED, payload: true});
      throw error;
    });
  };
};

const actions = {
  login,
  logout,
  setUser,
  setUserTourCompleted
};

export {actions, actionTypes};